import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { PrismButton, PrismTooltip } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface SettingsHotelAccessFormsAccessRightsDeleteCtaSignature {
  Args: {
    cellData: unknown;
    row: {
      isLocked?: boolean;
      isSelected?: boolean;
      onSubscriptionDelete: (subscriptionId: string) => void;
      subscriptionId: string;
    };
  };
}

const SettingsHotelAccessFormsAccessRightsDeleteCta = <template>
  <div>
    {{#if @row.isLocked}}
      <PrismButton
        @buttonType="ghost"
        @icon="lock"
        @isDisabled={{true}}
        @size="small"
      />
      <PrismTooltip
        @side="left"
        @text={{t "useraccess_rights_locked_content"}}
        @title={{t "useraccess_rights_locked"}}
      />
    {{else if @row.isSelected}}
      <PrismButton
        @buttonType="ghost"
        @icon="bin"
        @isDisabled={{true}}
        @size="small"
      />
      <PrismTooltip
        @side="left"
        @text={{t
          "settings.hotel_access.edit.multiple_selections.tooltip_text"
        }}
      />
    {{else}}
      <PrismButton
        @buttonType="ghost"
        @icon="bin"
        @isDisabled={{if @cellData false true}}
        @onClick={{fn @row.onSubscriptionDelete @row.subscriptionId}}
        @size="small"
        data-event-id="hotel-settings-hotels-edit-delete-uhr"
      />
      {{#unless @cellData}}
        <PrismTooltip
          @side="left"
          @text={{t "useraccess_rights_delete_content"}}
          @title={{t "useraccess_rights_delete"}}
        />
      {{/unless}}
    {{/if}}
  </div>
</template> satisfies TOC<SettingsHotelAccessFormsAccessRightsDeleteCtaSignature>;

export default SettingsHotelAccessFormsAccessRightsDeleteCta;
